import { css } from '@portal/styled-system/css'

import { useI18n } from '@/shared/lib/i18n'
import { Button, Modal, type ModalProps } from '@/shared/ui'

export type AccountReloginDialogProps = ModalProps & {
    onSwitchAccountButtonClick: () => void
    interactionDisabled?: boolean
}

export function AccountReloginDialog({
    onSwitchAccountButtonClick,
    interactionDisabled,
    ...modalProps
}: AccountReloginDialogProps) {
    const { i18n } = useI18n()

    return (
        <Modal {...modalProps}>
            <Modal.Header styles={css.raw({ backgroundColor: 'warning' })} icon="fa-solid fa-person-to-portal">
                {i18n.TEXT_accountRelogin_PORTAL_TITLE}
            </Modal.Header>
            <Modal.Body>
                <span dangerouslySetInnerHTML={{ __html: i18n.TEXT_accountRelogin_PORTAL_DESCR }} />
            </Modal.Body>
            <Modal.Buttons>
                <Button color="success" onPress={onSwitchAccountButtonClick} isDisabled={interactionDisabled}>
                    {i18n.TEXT_accountRelogin_PORTAL_BTN_SWITCH}
                </Button>
            </Modal.Buttons>
        </Modal>
    )
}
